export default __webpack_public_path__ + "2c9c69687a86dcaa73ea9743e3c9c8d2.png";